/// <amd-module name="Feed/Connect/Protocol" />
import { PackagingService } from "Feed/Core/PackagingService";
import { IUxFeedView } from "Feed/Core/UxFeedView";

export interface IProtocol {
    readonly name: string;
    readonly featureFlag?: string;
    getFeedUrl(packagingService: PackagingService, feed: IUxFeedView): string;
}

export abstract class PackagingProcotol implements IProtocol {
    protected constructor(readonly name: string, readonly featureFlag?: string) {}

    public abstract readonly area: string;
    public abstract getFeedUrl(packagingService: PackagingService, feed: IUxFeedView): string;
}
